import React, { useState } from 'react';
import { Check } from 'lucide-react';
import '../../styles/Dashboard.css';
import mixpanel from '../../utils/mixpanel'
import { API_URL } from '../../app/constants'

const PricingModal = ({ isOpen, onClose, source = 'Unknown' }) => {
  const [selectedPlan, setSelectedPlan] = useState('monthly');

  if (!isOpen) return null;

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .premium-paywall-modal {
            height: 85vh !important;
            padding-top: 50px !important;
            overflow-y: auto !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .premium-paywall-modal h2 {
            margin-bottom: 16px !important;
          }
          .pricing-options-row {
            flex: 1 !important;
            display: flex !important;
            align-items: stretch !important;
          }
        }
      `}</style>
      <div 
        className="premium-fullscreen-modal"
        onClick={onClose}
      >
        <div 
          className="premium-paywall-modal"
          onClick={(e) => e.stopPropagation()}
          style={{
            borderRadius: '12px',
            maxWidth: '900px',
            width: '90vw'
          }}
        >
        <div className="mobile-close-button" onClick={onClose}>
          ✕
        </div>
        <h2 style={{color: "#6B6B6B", textAlign: "center"}}>Choose your plan</h2>
        
        {/* Mobile Toggle Buttons */}
        <div className="mobile-plan-toggle">
          <button 
            className={`plan-toggle-btn ${selectedPlan === 'monthly' ? 'active' : ''}`}
            onClick={() => setSelectedPlan('monthly')}
          >
            Pay Monthly
          </button>
          <button 
            className={`plan-toggle-btn ${selectedPlan === 'lifetime' ? 'active' : ''}`}
            onClick={() => setSelectedPlan('lifetime')}
          >
            Lifetime • Best value
          </button>
        </div>
        
        <div className="pricing-options-row">
          {/* Free Option */}
          <div className="pricing-option free-option-desktop-only" style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
            <div className="pricing-option-content" style={{flex: "1"}}>
              <div className="premium-price">
                <span className="currency">USD</span> 0.00
              </div>
              <div className="latte-comparison" style={{minHeight: "60px"}}>Limited access</div>

              <div className="modal-button-container">
                <button
                  className="modal-button continue-free-button"
                  onClick={onClose}
                >
                  Continue Free
                </button>
              </div>

              <div className="desktop-features-list" style={{minHeight: "160px"}}>
                <div className="desktop-features-title">Free features</div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Diagnostic Test & 1st personalized training</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>1 free mock test</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Limited AI chat & feedback</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Limited analytics and support</span>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="pricing-divider"></div>

          {/* Monthly Option */}
          <div className={`pricing-option ${selectedPlan === 'monthly' ? 'mobile-active' : 'mobile-hidden'}`} style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
            <div className="pricing-option-content" style={{flex: "1"}}>
              <div className="premium-price">
                <span className="currency">USD</span> 15.00 <span className="period">monthly</span>
              </div>
              <div className="latte-comparison" style={{minHeight: "60px"}}>That's just <span className="highlight"><span className="drink-icon">🍵</span> 3 matcha lattes</span> per month</div>
              
              <div className="modal-button-container">
                <button
                  className="modal-button upgrade-now-button"
                  onClick={async () => {
                    mixpanel.track('Get Full Access', {
                      source: `${source} - Monthly`,
                      page: window.location.pathname
                    });
                    
                    try {
                      const token = localStorage.getItem('jwt');
                      console.log('Token:', token);
                      const response = await fetch(`${API_URL}/api/v2/payment/subscription`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({})
                      });
                      
                      if (response.ok) {
                        const data = await response.json();
                        window.location.href = data.checkout_url;
                      } else {
                        const errorData = await response.json();
                        console.error('Payment API error:', response.statusText, errorData);
                      }
                    } catch (error) {
                      console.error('Error calling payment API:', error);
                    }
                  }}
                >
                  Upgrade Now
                </button>
              </div>

              <div className="desktop-features-list" style={{minHeight: "160px"}}>
                <div className="desktop-features-title">Unlimited access to all features</div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Unlimited personalized trainings</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Unlimited full mock exams and analytics</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>New weekly exclusive listening contests</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Unlimited AI chat & feedback</span>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="pricing-divider"></div>

          {/* Lifetime Option */}
          <div className={`pricing-option ${selectedPlan === 'lifetime' ? 'mobile-active' : 'mobile-hidden'}`} style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
            <div className="pricing-option-content" style={{flex: "1"}}>
              <div className="premium-price">
                <span className="currency">USD</span> 100.00 <span className="period">one-time</span>
              </div>
              <div className="latte-comparison" style={{minHeight: "60px"}}>That's just <span className="highlight"><span className="drink-icon">🍵</span> 20 matcha lattes</span> for a lifetime of Japanese learning</div>
              
              <div className="modal-button-container">
                <button
                  className="modal-button upgrade-now-button"
                  onClick={async () => {
                    mixpanel.track('Get Full Access', {
                      source: `${source} - Lifetime`,
                      page: window.location.pathname
                    });
                    
                    try {
                      const token = localStorage.getItem('jwt');
                      const response = await fetch(`${API_URL}/api/v2/payment/lifetime`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({})
                      });
                      
                      if (response.ok) {
                        const data = await response.json();
                        window.location.href = data.checkout_url;
                      } else {
                        console.error('Payment API error:', response.statusText);
                      }
                    } catch (error) {
                      console.error('Error calling payment API:', error);
                    }
                  }}
                >
                  Upgrade Now
                </button>
              </div>

              <div className="desktop-features-list" style={{minHeight: "160px"}}>
                <div className="desktop-features-title">Unlimited access to all features</div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Unlimited personalized trainings</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Unlimited full mock exams and analytics</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>New weekly exclusive listening contests</span>
                </div>
                <div className="desktop-feature-item">
                  <div className="check-icon">
                    <Check size={16} />
                  </div>
                  <span>Unlimited AI chat & feedback</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Global features list only shown on mobile */}
        <div className="mobile-only-features">
          <div className="premium-features-title">Unlimited access to all features</div>

          <div className="premium-features-list">
            <div className="premium-feature-item">
              <div className="check-icon">
                <Check size={20} />
              </div>
              <span>Unlimited personalized trainings</span>
            </div>
            <div className="premium-feature-item">
              <div className="check-icon">
                <Check size={20} />
              </div>
              <span>Unlimited full mock exams and analytics</span>
            </div>
            <div className="premium-feature-item">
              <div className="check-icon">
                <Check size={20} />
              </div>
              <span>New weekly exclusive listening contests</span>
            </div>
            <div className="premium-feature-item">
              <div className="check-icon">
                <Check size={20} />
              </div>
              <span>Unlimited AI chat & feedback</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default PricingModal;